// extracted by mini-css-extract-plugin
export default {"body":"Prestations_body__-ONR-","majsite":"Prestations_majsite__IH0MW"};